// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiSort from "lumi-sort/lib/es6/src/LumiSort.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as Stdlib_List from "@rescript/runtime/lib/es6/Stdlib_List.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Primitive_int from "@rescript/runtime/lib/es6/Primitive_int.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";

function groupSortedBy(items, f) {
  return Stdlib_List.toArray(Stdlib_List.mapReverse(Stdlib_Array.reduce(items, /* [] */0, (grouped, item) => {
    let group = f(item);
    if (grouped !== 0) {
      let match = grouped.hd;
      if (Primitive_object.equal(group, match[0])) {
        return {
          hd: [
            group,
            {
              hd: item,
              tl: match[1]
            }
          ],
          tl: grouped.tl
        };
      }
    }
    return {
      hd: [
        group,
        {
          hd: item,
          tl: /* [] */0
        }
      ],
      tl: grouped
    };
  }), param => [
    param[0],
    Stdlib_List.toArray(Stdlib_List.reverse(param[1]))
  ]));
}

function groupBy(items, f) {
  return groupSortedBy(LumiSort.stableSortOn(items.map(item => [
    f(item),
    item
  ]), prim => prim[0]), prim => prim[0]).map(param => [
    param[0],
    param[1].map(prim => prim[1])
  ]);
}

function groupIntoDict(items, f) {
  let ret = {};
  items.forEach(item => {
    let key = f(item);
    let array = ret[key];
    if (array !== undefined) {
      array.push(item);
    } else {
      ret[key] = [item];
    }
  });
  return ret;
}

function roll(x, n) {
  let k = x.length;
  if (k === 0 || k === 1) {
    return x;
  }
  let rolls = Primitive_int.mod_(n + k | 0, k);
  return x.slice(x.length - rolls | 0, x.length).concat(x.slice(0, x.length - rolls | 0));
}

function adjacentPairs(xs) {
  return Belt_Array.zip(xs, roll(xs, -1));
}

function expect1(items) {
  if (items.length !== 1) {
    return {
      TAG: "Error",
      _0: `Expected array of length 1 but got array of length ` + items.length.toString()
    };
  }
  let item = items[0];
  return {
    TAG: "Ok",
    _0: item
  };
}

function reduce1(xs, f) {
  return Stdlib_Array.reduce(xs.slice(1), Stdlib_Option.getOrThrow(xs[0], undefined), f);
}

function mutate(xs, ix, f) {
  Stdlib_Option.forEach(xs[ix], x => {
    xs[ix] = f(x);
  });
}

function getMany(xs, ixs) {
  let ys = Stdlib_Array.make(ixs.length, undefined);
  ixs.forEach((inputIx, outputIx) => {
    ys[outputIx] = xs[inputIx];
  });
  return Stdlib_Array.keepSome(ys);
}

function concat(xss) {
  return [].concat(...xss);
}

function has(xs, y) {
  return xs.some(x => Primitive_object.equal(x, y));
}

function removeAll(xs, x) {
  return xs.filter(e => Primitive_object.notequal(e, x));
}

export {
  groupSortedBy,
  groupBy,
  groupIntoDict,
  roll,
  adjacentPairs,
  expect1,
  reduce1,
  mutate,
  getMany,
  concat,
  has,
  removeAll,
}
/* No side effect */
